import { checkVAT, countries } from '@accountable/jsvat';

const vat = function (node) {
  return checkVAT(node.value, countries).isValid;
};

export default vat;
